/**
 * Cache Bus - Cross-tab cache synchronization
 * Uses BroadcastChannel to share cache updates across browser tabs
 */

const bc = 'BroadcastChannel' in window ? new BroadcastChannel('tp-cache') : null;

/**
 * Broadcast cache update to other tabs
 * @param {string} key - Cache key that was updated
 */
export function broadcastCacheUpdate(key) {
  if (bc) {
    bc.postMessage({ 
      key, 
      timestamp: Date.now(),
      tabId: Math.random().toString(36).substr(2, 9) // Simple tab identifier
    });
    console.log('📡 CACHE BUS: Broadcasted update for', key);
  }
}

/**
 * Subscribe to cache updates from other tabs
 * @param {Function} onMessage - Callback when cache update is received
 * @returns {Function} Unsubscribe function
 */
export function subscribeCacheUpdates(onMessage) {
  if (!bc) {
    console.warn('📡 CACHE BUS: BroadcastChannel not supported');
    return () => {}; // No-op unsubscribe
  }
  
  const handleMessage = (event) => {
    const { key, timestamp, tabId } = event.data;
    console.log('📡 CACHE BUS: Received update for', key, 'from tab', tabId);
    onMessage({ key, timestamp, tabId });
  };
  
  bc.addEventListener('message', handleMessage);
  
  // Return unsubscribe function
  return () => {
    bc.removeEventListener('message', handleMessage);
  };
}

/**
 * Check if BroadcastChannel is supported
 * @returns {boolean} True if supported
 */
export function isBroadcastChannelSupported() {
  return !!bc;
}

/**
 * Get cache bus status
 * @returns {Object} Status information
 */
export function getCacheBusStatus() {
  return {
    supported: isBroadcastChannelSupported(),
    channelName: 'tp-cache',
    timestamp: Date.now()
  };
}














